import React from 'react';
import { Card, CardActionArea, Box, Typography } from '@mui/material';
import { radius } from '../../themes/smartinventoryTheme';

// The KPI tile used on all four overview pages. `delta.direction` (up/down/
// neutral) colours the pill by sign; `tone` tints the value for a warning/
// error figure (e.g. "5 items running low").
const MetricCard = ({ label, value, delta, sparkline, tone, onClick }) => {
  const deltaColor = !delta ? undefined
    : delta.direction === 'up' ? 'success.main'
    : delta.direction === 'down' ? 'error.main'
    : 'text.secondary';
  const deltaBg = !delta ? undefined
    : delta.direction === 'up' ? 'success.light'
    : delta.direction === 'down' ? 'error.light'
    : 'action.selected';

  const content = (
    <Box sx={{ p: 2 }}>
      {/* On a half-width phone tile the label and delta pill can't share one
          line, so the pill wraps underneath instead of covering the label. */}
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', columnGap: 1, rowGap: 0.5 }}>
        <Typography variant="body2" color="text.secondary" noWrap sx={{ minWidth: 0 }}>{label}</Typography>
        {delta && (
          <Typography
            variant="caption"
            fontWeight={600}
            sx={{ color: deltaColor, bgcolor: deltaBg, borderRadius: `${radius.pill}px`, px: 1, py: 0.25, whiteSpace: 'nowrap', flexShrink: 0 }}
          >
            {delta.text}
          </Typography>
        )}
      </Box>
      <Typography
        variant="h4"
        sx={{ mt: 0.5, color: tone === 'warning' ? 'warning.main' : tone === 'error' ? 'error.main' : 'text.primary' }}
      >
        {value}
      </Typography>
      {sparkline && sparkline.length > 0 && (
        <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: '3px', height: 24, mt: 1.5 }}>
          {sparkline.map((point, index) => {
            const max = Math.max(...sparkline, 1);
            const heightPct = Math.max(8, Math.round((point / max) * 100));
            return (
              <Box
                key={index}
                sx={{
                  width: 5,
                  height: `${heightPct}%`,
                  borderRadius: '2px 2px 0 0',
                  bgcolor: index === sparkline.length - 1 ? 'primary.main' : 'primary.light',
                }}
              />
            );
          })}
        </Box>
      )}
    </Box>
  );

  return (
    <Card>
      {onClick ? <CardActionArea onClick={onClick}>{content}</CardActionArea> : content}
    </Card>
  );
};

export default MetricCard;
